export default "__VITE_ASSET__BdY5OhCu__"